import { Outlet } from 'react-router-dom';
import { TrainerSidebar } from '../components/trainer/TrainerSidebar';

export const TrainerLayout = () => (
  <div className="flex min-h-screen bg-slate-50">
    <TrainerSidebar />
    <main className="flex-1 overflow-x-hidden">
      <Outlet />
    </main>
  </div>
);
